import React, { Component } from 'react';
import { Field } from 'react-final-form';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import Countries from '../../../components/countries';
import { SearchSelect, RemovableField } from '../../../shared/molecules/forms/SearchSelect';
import { isPercentage } from '../../../utils/validation';
import { generateSum } from '../accoundDetailsUtil';

const PERCENTANGE_LIMIT = 100;
class CountrySelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countriesList: Countries.map(country => ({
        id: country.name,
        labelText: country.name
      })),
      selectedCountries: []
    };

    this.countriesSelectionCallback = this.countriesSelectionCallback.bind(this);
    this.getsTurnovers = this.getsTurnovers.bind(this);
    this.handleTurnoverRemoveField = this.handleTurnoverRemoveField.bind(this);
  }
  componentWillMount() {
    if (this.props.getSelectedCountries) {
      const list = [];
      this.props.getSelectedCountries.forEach(country => {
        this.state.countriesList.map(cnt => {
          if (cnt.labelText === country) {
            list.push(country);
          }
          return cnt;
        });
      });
      this.setState({ selectedCountries: list });
    }
  }
  countriesSelectionCallback(selectedCountries) {
    this.setState({
      selectedCountries: selectedCountries
    });
    this.props.onAccountDetailsValueChange(selectedCountries);
  }

  getsTurnovers(name, percentFieldValidation, isPristine, formValues) {
    const { selectedCountries } = this.state;
    const { whatPercentAnnualOutgoingText, whatPercentAnnualOutgoingHelpText } = this.props;
    const showPercentageError = (val, pristine) => {
      if (pristine) {
        return false;
      }
      if (!val || generateSum(formValues) > PERCENTANGE_LIMIT) {
        return true;
      }
    };

    return (
      <div>
        <Field name={name} subscription={{ touched: true, error: true, active: true }}>
          {input => (
            <div>
              {selectedCountries.map((country, i) => (
                <Field
                  key={i}
                  name={`${name}[${i}][${country}]`}
                  component="input"
                  value={input.value}
                  validate={isPercentage}
                >
                  {({ input }) => (
                    <div>
                      <GenericFieldWrapper
                        title={whatPercentAnnualOutgoingText}
                        description={whatPercentAnnualOutgoingHelpText}
                      >
                        <RemovableField
                          key={country}
                          id={country}
                          name={`${name}[${i}][${country}]`}
                          value={input.value}
                          label={country}
                          description={country.description}
                          validationMessage={percentFieldValidation}
                          hasError={showPercentageError(input.value, isPristine)}
                          onRemoveField={this.handleTurnoverRemoveField}
                          suffix="%"
                          inputProps={input}
                        />
                      </GenericFieldWrapper>
                    </div>
                  )}
                </Field>
              ))}
            </div>
          )}
        </Field>
      </div>
    );
  }

  handleTurnoverRemoveField(custId) {
    const selectedCountries = this.state.selectedCountries.filter(country => country !== custId);
    this.setState({ selectedCountries });
    this.props.onAccountDetailsValueChange(selectedCountries, true);
  }

  render() {
    const {
      id,
      name,
      placeholder,
      label,
      accordionLabel,
      fieldValidation,
      percentFieldValidation,
      isPristine,
      formValues,
      helpText
    } = this.props;

    return (
      <ConditionalPanel isVisible>
        <SearchSelect
          id={id}
          name={name}
          searchPlaceholder={placeholder}
          label={label}
          accordionLabel={accordionLabel}
          searchItems={this.state.countriesList}
          selectedItems={this.state.selectedCountries}
          selectedSearchItems={this.countriesSelectionCallback}
          fieldValidation={fieldValidation}
          helpText={helpText}
        >
          {this.getsTurnovers(name, percentFieldValidation, isPristine, formValues)}
        </SearchSelect>
      </ConditionalPanel>
    );
  }
}

export default CountrySelect;
